// extracted by mini-css-extract-plugin
export default {"section":"GamesByRetention_section__AxEWK","listWrapper":"GamesByRetention_listWrapper__+l8fy"};